import { render, staticRenderFns } from "./PromotionAdd.vue?vue&type=template&id=5502e802"
import script from "./PromotionAdd.vue?vue&type=script&lang=js"
export * from "./PromotionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports